import { Injectable } from '@angular/core';
import {
  ISuceso,
  ICreateSuceso,
  IQueryParam,
  IUpdateSuceso,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class SucesosService {
  constructor(private http: HttpService) {}

  // Sucesos
  public getById(id: string): Observable<ISuceso> {
    return this.http.get(`${api}/sucesos/${id}`);
  }
  public getFiltered(queryParams?: IQueryParam): Observable<{
    data: ISuceso[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/sucesos`, { params });
  }
  public create(data: ICreateSuceso): Observable<ISuceso> {
    return this.http.post(`${api}/sucesos`, data);
  }
  public update(id: string, data: IUpdateSuceso): Observable<ISuceso> {
    return this.http.put(`${api}/sucesos/${id}`, data);
  }
  public delete(id: string): Observable<ISuceso> {
    return this.http.delete(`${api}/sucesos/${id}`);
  }
}
